import { Box, Typography } from '@mui/material'
import type { ProcurementFilters } from '../ProcurementPage'

interface Props {
  filters: ProcurementFilters
}

export default function ProcurementInvoiceListView({ filters }: Props) {
  return (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="h6" fontWeight={700}>
        Invoice
      </Typography>
      <Typography variant="body2" color="text.secondary">
        This tab will host the Procurement Invoice toolbar and list mapped from
        {' '}
        <strong>form_frmProcurementMainSubFormInvoice.txt</strong>
        {' '}
        and
        {' '}
        <strong>form_frmProcurementQryInvoice.txt</strong>
        , including New / Edit / Delete / Copy / Print BBGN / Accounting Input Invoices / Declaration Date behavior.
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Current header filters: startDate={filters.startDate}, endDate={filters.endDate}, isForcedClose=
        {filters.isForcedClose}
        .
      </Typography>
    </Box>
  )
}

